import React, { useState, useCallback } from "react";
import { debounce } from "throttle-debounce";
import { konturFocusGet } from "../../../utils/api";

import './styles.scss';

const InputKonturFocus = ({
    $locale,
    eventKey,
    label,
    required,
    disabled,
    readOnly,
    placeholder,
    error,
    value,
    onClick = () => { },
    onChange,
    onBlur,
}) => {
    const [organizationName, setOrganizationName] = useState(value?.organizationName || '');
    const [organizationInn, setOrganizationInn] = useState(value?.organizationInn || 0);
    const [organizationKpp, setOrganizationKpp] = useState(value?.organizationKpp || 0);
    const [organizationsList, setOrganizationsList] = useState([]);
    const [isListVisible, setListVisible] = useState(false);
    const [isHintHidden, setHintHidden] = useState(true);

    const handleSearchOrganization = (search) => {
        if (!search?.trim()) {
            setOrganizationsList([]);
            setListVisible(false);
        } else {
            konturFocusGet(eventKey, { search })
                .then((response) => {
                    const _organizationsList = response?.items || [];
                    setOrganizationsList(_organizationsList);
                    setListVisible(!!_organizationsList.length);
                })
                .catch((error) => {
                    console.error(error);
                    setListVisible(false);
                });
        }
    };

    const handleChangeSearch = useCallback(
        debounce(700, handleSearchOrganization)
        , []);

    const handleSetSerachValue = (value) => {
        if (!value) {
            setOrganizationInn('');
            setOrganizationKpp('');

            onChange('');
        }

        setOrganizationName(value);
        handleChangeSearch(value);
    }

    const handleChooseOrganization = (organization) => {
        setOrganizationInn(organization.inn);
        setOrganizationKpp(organization.kpp);
        setOrganizationName(organization.shortName);

        setListVisible(false);
        setHintHidden(true);

        onChange({
            organizationName: organization.shortName,
            organizationInn: organization.inn,
            organizationKpp: organization.kpp,
        });
    }

    const handleSetHint = () => {
        onClick();

        if (readOnly) {
            return;
        }

        setHintHidden(!!organizationName);
    }

    return (
        <div className="ui-input-component ui-input-kontur">
            {!!label && (
                <label
                    htmlFor="organizationName"
                    className={required ? 'input-required' : ''}
                >
                    {label}
                </label>
            )}
            <input
                className={error ? 'input-error' : ''}
                type="text"
                name="organizationName"
                value={organizationName || ''}
                required={required}
                disabled={disabled}
                readOnly={readOnly}
                placeholder={placeholder || ''}
                onClick={onClick}
                onChange={(e) => handleSetSerachValue(e.target.value)}
                onBlur={onBlur}
            />
            {!!(organizationsList.length && isListVisible) && (
                <ul className="ui-input-kontur__list">
                    {organizationsList.map((organization) => (
                        <li
                            key={organization.inn}
                            onClick={() => handleChooseOrganization(organization)}
                            className="ui-input-kontur__list-item"
                        >
                            <span><strong>{organization.shortName}</strong></span>
                            <span>{organization.address}</span>
                        </li>
                    ))}
                </ul>
            )}
            <div className="ui-input-kontur__fields">
                <input
                    type="text"
                    placeholder={$locale.get('registration.field.inn')}
                    name="organizationInn"
                    value={organizationInn || ''}
                    disabled={disabled}
                    className={error ? 'input-error' : ''}
                    readOnly
                    onClick={handleSetHint}
                />
                <span className="kontur-focus__fields-dash">&#8212;</span>
                <input
                    type="text"
                    placeholder={$locale.get('registration.field.kpp')}
                    name="organizationKpp"
                    value={organizationKpp || ''}
                    disabled={disabled}
                    className={error ? 'input-error' : ''}
                    readOnly
                    onClick={handleSetHint}
                />
            </div>
        </div>
    );
};

export default InputKonturFocus;
